import { Directive, ElementRef, OnInit } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

@Directive({
  selector: 'form'
})
export class FormSubmitDirective implements OnInit {

  public submit$: Observable<Event>;

  constructor(private host: ElementRef<HTMLFormElement>) {
    this.submit$ = fromEvent(this.element, 'submit').pipe(shareReplay(1));
  }

  ngOnInit(): void {

  }

  get element() {
    return this.host.nativeElement;
  }

}
